import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme, Theme } from "@fluentui/react-components";
import "react-quill/dist/quill.snow.css";

console.log("MarginPro: index.tsx Entry Point Loading...");

if (typeof window !== "undefined" && (window as any).trustedTypes && (window as any).trustedTypes.createPolicy) {
  if (!(window as any).trustedTypes.defaultPolicy) {
    (window as any).trustedTypes.createPolicy("default", {
      createHTML: (string: string) => string,
      createScriptURL: (string: string) => string,
      createScript: (string: string) => string,
    });
  }
}

const marginTheme: Theme = {
  ...webLightTheme,
  colorBrandBackground: "#003314",
  colorBrandBackgroundHover: "#00260F",
  colorBrandBackgroundPressed: "#001A0A",
  colorBrandBackgroundSelected: "#003314",
  colorBrandForeground1: "#003314",
  colorBrandForeground2: "#00260F",
  colorCompoundBrandForeground1: "#003314",
  colorCompoundBrandForeground1Hover: "#00260F",
  colorCompoundBrandForeground1Pressed: "#001A0A",
  colorCompoundBrandStroke: "#003314",
  colorCompoundBrandStrokeHover: "#00260F",
  colorCompoundBrandStrokePressed: "#001A0A",
  colorCompoundBrandBackground: "#003314",
  colorCompoundBrandBackgroundHover: "#00260F",
  colorCompoundBrandBackgroundPressed: "#001A0A",
};

const renderApp = () => {
  console.log("MarginPro: Attempting React rendering...");
  const rootElement: HTMLElement | null = document.getElementById("container");
  if (!rootElement) {
    console.error("MarginPro: FATAL - Container element not found in DOM!");
    return;
  }
  
  const root = createRoot(rootElement);
  root.render(
    <FluentProvider theme={marginTheme}>
      <App />
    </FluentProvider>
  );
  console.log("MarginPro: React render command sent.");
};

// FAILSAFE: Always attempt render immediately to prevent blank screen hangs
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}

if (typeof Office !== "undefined") {
  Office.onReady((info) => {
    console.log("MarginPro: Office.js Ready Handshake:", info);
  });
}

if (typeof (window as any).global === "undefined") {
  (window as any).global = window;
}
